// delta: added to the current value. multiply: scales the current size (1 leaves it). set: replaces the current value.
// Rotation is in degrees.
export const PROPERTIES = [
    { id: 'x', label: 'Position X', defaultValue: 0, step: 1, mode: 'delta' },
    { id: 'y', label: 'Position Y', defaultValue: 0, step: 1, mode: 'delta' },
    { id: 'rotationX', label: 'Rotation X', defaultValue: 0, step: 1, mode: 'delta' },
    { id: 'rotationY', label: 'Rotation Y', defaultValue: 0, step: 1, mode: 'delta' },
    { id: 'rotation', label: 'Rotation Z', defaultValue: 0, step: 1, mode: 'delta' },
    { id: 'scale', label: 'Scale', defaultValue: 1, step: 0.01, mode: 'multiply' },
    { id: 'scaleX', label: 'Scale X', defaultValue: 1, step: 0.01, mode: 'multiply' },
    { id: 'scaleY', label: 'Scale Y', defaultValue: 1, step: 0.01, mode: 'multiply' },
    { id: 'alpha', label: 'Alpha', defaultValue: 1, step: 0.01, mode: 'set' },
    { id: 'visible', label: 'Visible', defaultValue: true, type: 'boolean', mode: 'set' },
];

export const EASES = [
    'none',
    'power1.in',
    'power1.out',
    'power1.inOut',
    'power2.in',
    'power2.out',
    'power2.inOut',
    'power3.in',
    'power3.out',
    'power3.inOut',
    'back.in(1.7)',
    'back.out(1.7)',
    'sine.inOut',
];

export const getProperty = (id) => PROPERTIES.find((property) => property.id === id);
